import { useT } from "../lang/LangContext";

export function Hero() {
  const t = useT();

  return (
    <section
      id="top"
      style={{
        position: "relative",
        padding: "72px 20px 40px",
        maxWidth: 1180,
        margin: "0 auto",
      }}
    >
      <div
        style={{
          display: "inline-block",
          fontSize: 12,
          letterSpacing: "0.22em",
          border: "3px solid var(--fg)",
          padding: "6px 12px",
          marginBottom: 28,
          background: "var(--bg)",
        }}
      >
        {t(
          "SENIOR SOFTWARE ENGINEER / UBERLÂNDIA, BRAZIL",
          "ENGENHEIRO DE SOFTWARE SÊNIOR / UBERLÂNDIA, BRASIL"
        )}
      </div>
      <h1
        className="glitch-title"
        style={{
          margin: 0,
          fontFamily: "'Archivo Black',sans-serif",
          fontSize: "clamp(40px,8vw,104px)",
          lineHeight: 0.84,
          letterSpacing: "-0.045em",
          textTransform: "uppercase",
        }}
      >
        Rodrigo
        <br />
        <span
          style={{
            color: "var(--accent)",
            WebkitTextStroke: "2px var(--fg)",
          }}
        >
          Ferreira
        </span>
      </h1>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 28,
          alignItems: "flex-end",
          justifyContent: "space-between",
          marginTop: 36,
        }}
      >
        <p
          style={{
            margin: 0,
            maxWidth: 560,
            fontSize: 17,
            lineHeight: 1.6,
          }}
        >
          {t(
            "Five years shipping production systems: AI automation, SaaS, cloud platforms. I own the thing end to end: architecture, delivery, CI/CD, monitoring, and the 3AM pager.",
            "Cinco anos entregando sistemas em produção: automação com IA, SaaS e plataformas em nuvem. Eu assumo a coisa toda: arquitetura, entrega, CI/CD, monitoramento e o plantão das 3h da manhã."
          )}
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
          <a
            href="#work"
            className="btn btn-press"
            style={{
              fontSize: 14,
              letterSpacing: "0.06em",
              background: "var(--accent)",
              color: "var(--bg)",
              padding: "14px 20px",
              boxShadow: "7px 7px 0 var(--fg)",
            }}
          >
            {t("SEE THE WORK", "VER O TRABALHO")}
          </a>
          <a
            href="#contact"
            className="btn btn-outline-invert"
            style={{
              fontSize: 14,
              letterSpacing: "0.06em",
              background: "transparent",
              color: "var(--fg)",
              padding: "14px 20px",
              boxShadow: "7px 7px 0 var(--accent)",
            }}
          >
            {t("HIRE ME", "ME CONTRATE")}
          </a>
        </div>
      </div>
    </section>
  );
}
